import React from "react";
import styles from "./Customers.module.sass";
import Overview from "./Overview";
import StatProspect from "./StatProspect";
import GraphSales from "./GraphSales";

const SessionsFormationDashboard = () => {
  return (
    <>
      <div className={styles.shop}>
        <div className={styles.background}>
          <img src="/images/content/bg-shop.jpg" alt="Background" />
        </div>
        <Overview 
          className={styles.card} 
        />
        <div className={styles.row}>
          <div className={styles.col}>
            <GraphSales className={styles.card} />
          </div>
          <div className={styles.col}>
            <StatProspect className={styles.card} />
          </div>
        </div>

      </div>
    </>
  );
};

export default SessionsFormationDashboard;
